// extracted by mini-css-extract-plugin
module.exports = {"mainPanel":"styles_mainPanel__NGAkx","tabsContainer":"styles_tabsContainer__3_S04"};